<template>
  <div
    v-bind:style="{
      'margin-left': marginLeft,
      width: width,
    }"
  >
    <p class="tanggal">Last Update: Nov 18, 2024</p>
    <p class="title-1">Selamat datang di Kebijakan Privasi PT Indo Fin Tek.</p>
    <p class="Desc">
      Privasi Anda sangat penting bagi kami. Di PT Indo Fin Tek, kami
      berkomitmen untuk melindungi dan menjaga kerahasiaan informasi data
      pribadi Anda. Kebijakan privasi ini dirancang untuk memberikan pemahaman
      yang transparan tentang bagaimana kami mengumpulkan, menggunakan, dan
      melindungi informasi pribadi yang Anda berikan ketika menggunakan layanan
      kami. Kami senantiasa mematuhi ketentuan hukum yang berlaku di Indonesia
      terkait perlindungan privasi dan data pribadi, khususnya Undang-Undang
      Nomor 27 Tahun 2022 tentang Pelindungan Data Pribadi beserta perubahannya,
      yang lebih dikenal sebagai "UU PDP," beserta aturan terkait lainnya. Kami
      berkomitmen untuk memastikan bahwa data Anda diproses dengan aman dan
      sesuai dengan standar hukum yang berlaku. Kami mengajak Anda untuk membaca
      kebijakan privasi ini secara seksama guna memahami hak dan perlindungan
      Anda dalam berinteraksi dengan PT Indo Fin Tek.
    </p>
    <p class="Desc">
      <strong>PT Indo Fin Tek (“Dompet Kilat”)</strong> adalah badan hukum
      indonesia selaku penyelenggara Layanan Pendanaan Bersama Berbasis
      Teknologi Informasi (LPBBTI) secara konvensional serta telah berizin dan
      diawasi oleh Otoritas Jasa Keuangan. Aktvitas PT Indo Fin Tek tunduk
      kepada seluruh ketentuan peraturan perundang-undangan yang terkait dengan
      LPBBTI
    </p>
    <div style="padding-bottom: 20px;">
      <v-expansion-panels>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <div style="font-size: 14px; font-weight: 600;">Latar Belakang</div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <div class="Desc">
              Memastikan bahwa seluruh data pribadi yang dikumpulkan, dikelola,
              dan disimpan oleh PT Indo Fin Tek dilindungi secara aman dan
              sesuai dengan ketentuan hukum yang berlaku, khususnya
              Undang-Undang Pelindungan Data Pribadi. Kebijakan ini bertujuan
              melindungi hak individu, memastikan keamanan dan kerahasiaan
              informasi, serta mencegah penyalahgunaan atau kebocoran data. PT
              Indo Fin Tek berkomitmen untuk menjaga kepercayaan pelanggan,
              mitra, dan karyawan dengan memastikan bahwa data pribadi diproses
              secara transparan, hanya digunakan untuk tujuan yang sah, dan
              dikelola sesuai dengan
              <strong>prinsip-prinsip perlindungan data yang berlaku.</strong>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>

    <div style="padding-bottom: 20px;">
      <v-expansion-panels>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <div style="font-size: 14px; font-weight: 600;">Ruang Lingkup</div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <div class="Desc">
              Ruang lingkup kebijakan privasi dalam SOP PT Indo Fin Tek mencakup
              seluruh kegiatan pengumpulan, pengolahan, penyimpanan, dan
              pemusnahan data pribadi yang dilakukan oleh Perusahaan. Kebijakan
              ini berlaku bagi seluruh karyawan, Perusahaan, mitra bisnis,
              vendor, serta pihak ketiga yang bekerja sama dengan PT Indo Fin
              Tek dalam menangani data pribadi, baik dari pelanggan, karyawan,
              maupun pemangku kepentingan lainnya. Selain itu, kebijakan ini
              mencakup semua jenis data pribadi yang diperoleh melalui berbagai
              media, termasuk data fisik dan digital, serta mengatur bagaimana
              data tersebut dilindungi sesuai dengan peraturan yang berlaku. PT
              Indo Fin Tek memastikan bahwa seluruh pihak yang terlibat dalam
              pengelolaan data mematuhi kebijakan privasi ini untuk menjamin
              keamanan, integritas, dan kerahasiaan informasi.
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>

    <div style="padding-bottom: 20px;">
      <v-expansion-panels>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <div style="font-size: 14px; font-weight: 600;">
              Data Pribadi ini Dikelola Sesuai dengan Berasaskan:
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <div class="Desc">
              Memastikan bahwa seluruh data pribadi yang dikumpulkan, dikelola,
              dan disimpan oleh PT Indo Fin Tek dilindungi secara aman dan
              sesuai dengan ketentuan hukum yang berlaku, khususnya
              Undang-Undang Pelindungan Data Pribadi. Kebijakan ini bertujuan
              melindungi hak individu, memastikan keamanan dan kerahasiaan
              informasi, serta mencegah penyalahgunaan atau kebocoran data. PT
              Indo Fin Tek berkomitmen untuk menjaga kepercayaan pelanggan,
              mitra, dan karyawan dengan memastikan bahwa data pribadi diproses
              secara transparan, hanya digunakan untuk tujuan yang sah, dan
              dikelola sesuai dengan
              <strong>prinsip-prinsip perlindungan data yang berlaku.</strong>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>

    <div style="padding-bottom: 20px;">
      <v-expansion-panels>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <div style="font-size: 14px; font-weight: 600;">
              Data Pribadi ini Dikelola Sesuai dengan Berasaskan:
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <div class="Desc">
              <ul>
                <li>Perlindungan;</li>
                <li>Kepastian Hukum;</li>
                <li>Kepentingan Umum;</li>
                <li>Kemanfaatan;</li>
                <li>Kehati-hatian;</li>
                <li>Keseimbangan;</li>
                <li>Pertanggungjawaban; dan</li>
                <li>Kerahasiaan.</li>
              </ul>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>

    <div style="padding-bottom: 20px;">
      <v-expansion-panels>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <div style="font-size: 14px; font-weight: 600;">
              Referensi
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <div class="Desc">
              <ul>
                <li>
                  Undang-Undang Nomor 27 Tahun 2022 tentang Pelindungan Data
                  Pribadi
                </li>
                <li>
                  Peraturan Otoritas Jasa Keuangan Nomor 22 Tahun 2023 tentang
                  Pelindungan Konsumen dan Masyarakat di Sektor Jasa Keuangan
                </li>
              </ul>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>

    <div style="padding-bottom: 20px;">
      <v-expansion-panels>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <div style="font-size: 14px; font-weight: 600;">
              Definisi Data Pribadi
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <div class="Desc">
              <ul>
                <li>
                  <strong>Data Pribadi</strong> adalah data tentang orang
                  perseorangan yang teridentifikasi atau dapat diidentifikasi
                  secara tersendiri atau dikombinasi dengan informasi lainnya
                  baik secara langsung maupun tidak langsung melalui sistem
                  elektronik atau non-elektronik.
                </li>
                <li>
                  <strong>Perlindungan Data</strong> dan/atau Informasi adalah
                  Perlindungan data dan/atau informasi konsumen dalam proses
                  kerja sama dilakukan antara lain dengan menjaga kerahasiaan
                  serta keamanan data dan/atau informasi konsumen.
                </li>
                <li>
                  <strong>Subjek Data Pribadi</strong> adalah orang perseorangan
                  yang pada dirinya melekat Data Pribadi.
                </li>
                <li>
                  <strong>Informasi</strong> adalah keterangan, pernyataan,
                  gagasan, dan tanda-tanda yang mengandung nilai, makna, dan
                  pesan, baik data, fakta, maupun penjelasannya yang dapat
                  dilihat, didengar, dan dibaca yang disajikan dalam berbagai
                  kemasan dan format sesuai dengan perkembangan teknologi
                  informasi dan komunikasi secara elektronik maupun
                  nonelektronik.
                </li>
                <li>
                  <strong>Pengendali Data Pribadi</strong> adalah setiap orang,
                  badan publik, dan organisasi internasional yang bertindak,
                  sendiri-sendiri atau bersama-sama dalam menentukan tujuan dan
                  melakukan kendali pemrosesan Data Pribadi.
                </li>
                <li>
                  <strong>Prosesor Data Pribadi</strong> adalah setiap orang,
                  badan publik, dan organisasi internasional yang bertindak
                  sendiri-sendiri atau bersama-sama dalam melakukan pemrosesan
                  Data Pribadi atas nama Pengendali Data Pribadi.
                </li>
              </ul>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>

    <div style="padding-bottom: 20px;">
      <v-expansion-panels>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <div style="font-size: 14px; font-weight: 600;">
              Legalitas Pemrosesan Data Pribadi
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <div class="Desc">
              <ul>
                <li>
                  <strong
                    >Dasar Pemrosesan Pengolahan Data Pribadi dilakukan selama
                    PT Indo Fin Tek memenuhi salah satu atau beberapa syarat
                    pemrosesan berikut:</strong
                  >
                  <ul>
                    <li>
                      PT Indo Fin Tek telah memperoleh persetujuan dari Anda
                      secara jelas dan sah;
                    </li>
                    <li>
                      PT Indo Fin Tek menjalankan hak dan kewajibannya sesuai
                      dengan perjanjian yang ada dengan Anda;
                    </li>
                    <li>
                      PT Indo Fin Tek perlu menjalankan kewenangan atau memenuhi
                      kewajiban sesuai dengan peraturan perundang-undangan atau
                      perintah dari otoritas yang berwenang;
                    </li>
                    <li>
                      PT Indo Fin Tek harus memenuhi kepentingan sah lainnya,
                      dengan tetap menjaga keseimbangan antara kepentingan PT
                      Indo Fin Tek dan hak-hak Anda.
                    </li>
                  </ul>
                </li>
                <li>
                  <strong>Tujuan Pemrosesan Data Pribadi </strong>
                  <ul>
                    <li>
                      Pengelolaan produk dan layanan PT Indo Fin Tek, termasuk
                      pemrosesan profil dan penilaian, bertujuan untuk
                      meningkatkan pelayanan kepada Anda serta mengelola risiko
                      bagi PT Indo Fin Tek.
                    </li>
                    <li>
                      Kepatuhan terhadap peraturan perundang-undangan dan
                      perintah dari regulator, aparat penegak hukum, serta
                      lembaga berwenang lainnya.
                    </li>
                  </ul>
                </li>
                <li>
                  <strong>Hak Anda sebagai Subjek Data Pribadi</strong>
                </li>
              </ul>
              Bahwa mengerti pentingnya Data Pribadi bagi subjek data pribad,
              maka dari itu, berikut kami informasikan hal-hal yang Anda miliki
              sebagai Subjek Data Pribadi:
              <ol>
                <li>
                  <strong>Hak Atas Informasi dan Akses</strong>
                  <p>
                    Anda berhak mengetahui identitas pihak yang meminta Data
                    Pribadi, tujuan permintaan tersebut, serta mendapatkan
                    salinan Data Pribadi. PT Indo Fin Tek akan menyediakan akses
                    informasi ini melalui saluran resmi yang tersedia.
                  </p>
                </li>
                <li>
                  <strong>Hak Atas Perbaikan Data</strong>
                  <p>
                    Anda memiliki hak untuk melengkapi, memperbarui, dan/atau
                    memperbaiki Data Pribadi yang salah atau tidak akurat.
                  </p>
                </li>
                <li>
                  <strong
                    >Hak untuk Mendapatkan, Menggunakan dan/atau Mengirimkan
                    Data Pribadi ke Pihak Lain</strong
                  >
                  <p>
                    Anda berhak untuk mengakses, menggunakan, atau memberikan
                    Data Pribadi yang disimpan oleh PT Indo Fin Tek kepada pihak
                    ketiga, asalkan sistem komunikasi yang digunakan oleh PT
                    Indo Fin Tek dan pihak ketiga tersebut aman.
                  </p>
                </li>
                <li>
                  <strong
                    >Hak untuk Mengakhiri Pemrosesan, Menghapus dan/atau
                    Memusnahkan Data Pribadi</strong
                  >
                  <p>
                    Anda memiliki hak untuk menghentikan pemrosesan, menghapus,
                    atau memusnahkan Data Pribadi Anda. Anda setuju untuk
                    memberi PT Indo Fin Tek waktu yang diperlukan untuk
                    menyelesaikan proses penghentian, penghapusan, atau
                    pemusnahan Data Pribadi Anda. Untuk melaksanakan hak
                    tersebut, Anda dapat menghubungi PT Indo Fin Tek melalui
                    saluran komunikasi yang tersedia.
                  </p>
                  <p>
                    <strong
                      >Kewajiban PT Indo Fin Tek untuk menghapus dan memusnahkan
                      Data Pribadi Anda tidak berlaku dalam kasus-kasus
                      berikut:</strong
                    >
                  </p>
                  <ul>
                    <li>Untuk kepentingan pertahanan dan keamanan nasional;</li>
                    <li>Untuk kepentingan penegakan hukum;</li>
                    <li>
                      Untuk kepentingan umum dalam penyelenggaraan negara; atau
                    </li>
                    <li>
                      Untuk kepentingan pengawasan sektor jasa keuangan,
                      moneter, sistem pembayaran, dan stabilitas sistem keuangan
                      dalam rangka penyelenggaraan negara.
                    </li>
                  </ul>
                </li>
                <li>
                  <strong>Penyimpanan dan Keamanan</strong>
                  <ul>
                    <li>
                      <strong>Penyimpanan Data:</strong> Kami melakukan
                      penyimpanan Data Pribadi Anda dengan teknologi enkripsi
                      sesuai standar ISO 27001 untuk memastikan keamanan Data
                      Pribadi Anda.
                    </li>
                    <li>
                      <strong>Enkripsi:</strong> Mengenkripsi data pribadi baik
                      selama transmisi maupun penyimpanan untuk melindungi dari
                      akses yang tidak sah.
                    </li>
                    <li>
                      <strong>Backup dan Recovery:</strong> Melakukan
                      pencadangan data secara rutin dan menyimpan cadangan
                      dengan cara yang aman. Memastikan adanya rencana pemulihan
                      bencana yang mencakup perlindungan data pribadi.
                    </li>
                  </ul>
                </li>
                <li>
                  <strong>Pelatihan terhadap Perlindungan Data Pribadi</strong>
                  <p>
                    Menyelenggarakan pelatihan rutin untuk karyawan tentang
                    perlindungan data pribadi, kebijakan perusahaan, dan
                    prosedur terkait, guna meningkatkan kesadaran tentang
                    pentingnya perlindungan data pribadi dan tanggung jawab
                    individu masing-masing.
                  </p>
                </li>
                <li>
                  <strong>Peninjauan dan Pembaruan</strong>
                  <ul>
                    <li>
                      <strong>Peninjauan Berkala:</strong> Melakukan peninjauan
                      dan pembaruan SOP ini secara rutin untuk memastikan
                      kepatuhan terhadap perubahan peraturan dan praktik
                      terbaik.
                    </li>
                    <li>
                      <strong>Dokumentasi:</strong> Menyimpan catatan mengenai
                      peninjauan, perubahan, pelatihan, dan insiden yang
                      berkaitan dengan data pribadi.
                    </li>
                  </ul>
                </li>
                <li>
                  <strong>Tanggung Jawab</strong>
                  <ul>
                    <li>
                      <strong>Officer Perlindungan Data (DPO):</strong>
                      Bertanggung jawab untuk mengawasi implementasi SOP ini dan
                      memastikan kepatuhan terhadap UU PDP (Pasal 35 UU PDP).
                    </li>
                    <li>
                      <strong>Tim IT:</strong> Menangani aspek teknis
                      perlindungan data, termasuk pengamanan sistem, enkripsi,
                      dan manajemen akses.
                    </li>
                  </ul>
                </li>
                <li>
                  <strong>Perubahan Kebijakan Privasi</strong>
                  <p>
                    Kami berhak mengubah, memodifikasi, atau memperbaharui
                    pemberitahuan privasi PT Indo Fin Tek ini kapan saja. Kami
                    akan menginformasikan perubahan, memodifikasi, atau
                    pembaruan tersebut kepada Anda dengan cara menampilkan
                    perubahan tersebut di situs web kami sehingga Anda dapat
                    selalu mengetahui mengenai Data Pribadi apa yang kami
                    kumpulkan.
                  </p>
                  <p>
                    Dengan adanya Pemberitahuan Privasi yang baru, maka
                    Pemberitahuan Privasi yang merupakan versi sebelumnya
                    dinyatakan tidak berlaku. Pemberitahuan Privasi yang berlaku
                    adalah yang terbaru yang ditampilkan di situs ini.
                  </p>
                </li>
                <li>
                  <strong>Hubungi PT Indo Fin Tek</strong>
                  <p>
                    PT Indo Fin Tek selalu siap membantu dan memberikan dukungan
                    terbaik kepada Anda serta pihak-pihak terkait. Untuk
                    pertanyaan, masukan, atau keluhan terkait layanan PT Indo
                    Fin Tek, silakan hubungi tim layanan pelanggan melalui
                    saluran resmi yang telah kami sediakan. Anda dapat
                    menghubungi PT Indo Fin Tek melalui email di
                    <em>[alamat email]</em> atau telepon di
                    <em>[nomor telepon]</em>. Seluruh pertanyaan dan keluhan
                    akan diproses dengan cepat dan sesuai dengan standar
                    operasional yang berlaku. PT Indo Fin Tek berkomitmen untuk
                    terus meningkatkan pelayanan dan memastikan kepuasan
                    pelanggan.
                  </p>
                </li>
              </ol>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>

    <div style="padding-bottom: 20px;">
      <v-expansion-panels>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <div style="font-size: 14px; font-weight: 600;">
              Pengungkapan dan Pembukaan Akses
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <div class="Desc">
              Kami berkomitmen untuk melindungi kerahasiaan data pribadi Anda. Namun demikian, Anda memahami bahwa kami berhak mengungkapkan data pribadi Anda kepada pihak-pihak tertentu yang relevan dengan operasional bisnis kami sebagai penyedia layanan pendanaan bersama berbasis teknologi. Pihak-pihak tersebut dapat meliputi, namun tidak terbatas pada:
              <ul>
                <li>
                  Direktur, Komisaris, atau Karyawan PT Indo Fin Tek
                </li>
                <li>
                  Mitra bisnis PT Indo Fin Tek, sebagai penyedia layanan pembayaran, analisis data, dan jasa pendukung lainnya
                </li>
                <li>
                  Fintech Data Center (FDC) yang didirikan oleh Asosiasi Fintech Pendanaan Bersama Indonesia (AFPI), untuk keperluan pelaporan data kredit Anda sebagai Penerima Dana di PT Indo Fin Tek
                </li>
                <li>
                  PT Pemeringkat Efek Indonesia (PEFINDO)
                </li>
                <li>
                  pihak-pihak lain yang terkait dengan kegiatan usaha PT Indo Fin Tek; dan
                </li>
                <li>
                  Otoritas Jasa Keuangan, Pusat Pelaporan dan Analisis Transaksi Keuangan, serta pihak yang berwenang lainnya sesuai dengan ketentuan peraturan perundang-undangan
                </li>
              </ul>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      marginLeft: `${window.innerWidth / 8}px`,
      width: `${window.innerWidth / 8}px`,
      height: `${window.innerWidth / 8}px`,
    };
  },
  mounted() {
    this.onResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.resizeEventHandler);
  },
  created() {
    this.resizeEventHandler();
    window.addEventListener("resize", this.resizeEventHandler);
  },
  methods: {
    resizeEventHandler() {
      this.marginLeft = `${window.innerWidth / 4}px`;
      this.width = `${window.innerWidth / 2}px`;
      this.height = `${window.innerWidth / 3}px`;
    },
    onResize() {
      this.windowSize = { x: window.innerWidth, y: window.innerHeight };
    },
  },
};
</script>
<style scoped>
.tanggal {
  flex-grow: 0;
  margin: 0 0 24px;
  font-family: Sora;
  font-size: 20px;
  font-weight: 300;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: -1px;
  text-align: left;
  color: #767676;
}
.title-1 {
  flex-grow: 0;
  margin: 24px 0 16px;
  font-family: Sora;
  font-size: 18px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: -0.9px;
  text-align: left;
  color: #252525;
}
.Desc {
  flex-grow: 0;
  margin: 16px 0 24px;
  font-family: Inter;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: justify;
  color: #252525;
}

.Ellipse {
  width: 4px;
  height: 4px;
  flex-grow: 0;
  margin: 4px 8px 4px 0;
  background-color: #252525;
}
.points {
  /* height: 20px; */
  flex-grow: 0;
  margin: 10px 0 0 60px;
  font-family: Sora;
  font-size: 14px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  text-align: left;
  color: #252525;
}
</style>
